import { Phone, MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ContactDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle className="text-2xl font-bold text-center text-[#1F2937]" style={{ fontFamily: "Manrope" }}>
          Contact Us
        </DialogTitle>
        <DialogDescription className="text-center">
          Choose how you'd like to reach us for an instant cash offer!
        </DialogDescription>
      </DialogHeader>

      <div className="flex flex-col gap-4 mt-6">
        <a
          href="tel:+19049559646"
          className="flex items-center justify-center gap-3 bg-[#0F5132] hover:bg-[#0B3D25] text-white rounded-xl px-6 py-5 font-bold text-lg transition-all hover:-translate-y-0.5 shadow-lg"
          data-testid="contact-call-btn"
        >
          <Phone className="w-6 h-6" />
          <span>Call (904) 955-9646</span>
        </a>

        <a
          href="sms:+19049559646"
          className="flex items-center justify-center gap-3 bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-xl px-6 py-5 font-bold text-lg transition-all hover:-translate-y-0.5 shadow-lg"
          data-testid="contact-text-btn"
        >
          <MessageCircle className="w-6 h-6" />
          <span>Text (904) 955-9646</span>
        </a>
      </div>

      <p className="text-center text-sm text-[#4B5563] mt-4">
        Text us a photo of your supplies for a fast quote!
      </p>
    </DialogContent>
  </Dialog>
);
